import React from 'react'
import { reduxForm, Field } from 'redux-form'

import classNames from './common.css'
import Modal from './Modal'
import ConfirmButtons from '../ConfirmButtons'
import LoadingSpinner from '../LoadingSpinner'
import ToggleForm from '../ToggleForm'
import Checklist from '../Checklist'
import { PresentOptionsFields } from '../present/PresentOptionsForm'
import { pluralize } from '../../utils/string'

function SaveAlbum ({ handleSubmit, onSubmit, submitting, closeModal, title, canSave, addingToPlaylist, lists, albumLists, defaultSort, presentTypeSelected }) {
  const isOnSearchPage = /\/search$/.test(window.location.pathname)
  return (
    <Modal title={title} onClose={closeModal}>
      <form className={classNames.form}>
        <Field
          component={Input}
          props={{ label: 'Album Name' }}
          type='text'
          name='name'
          required
          autoFocus={isOnSearchPage}
        />
        <ToggleForm
          showLabel='Set Presentation Defaults'
          // Hacky way of showing the presentation options when opening the save
          // modal from the 'edit presentation options' button in the info page
          initialOpen={/\/info$/.test(window.location.pathname)}>
          <PresentOptionsFields
            defaultSort={defaultSort}
            presentTypeSelected={presentTypeSelected}
          />
        </ToggleForm>
        <ToggleForm showLabel='Add album to groups' hideLabel='Hide album groups'>
          <div className={classNames.label}>
            Album Groups
            <Field
              component={ListPicker}
              name='lists'
              props={{ lists }}
              defaultValue={albumLists || []}
            />
            <Field
              component={Input}
              type='text'
              name='createList'
              placeholder='New group'
            />
          </div>
        </ToggleForm>
        {addingToPlaylist &&
          <p className={classNames.centerNote}>
            Adding album to playlist: <strong>{addingToPlaylist.name || 'New playlist'}</strong>
          </p>
        }
        <ConfirmButtons
          onCancel={closeModal}
          onConfirm={handleSubmit}
          confirmDisabled={submitting}
          confirmHidden={!canSave || isOnSearchPage}
          middleButtons={[{
            onClick: handleSubmit(data => onSubmit({ ...data, id: undefined })),
            text: isOnSearchPage ? 'Save' : 'Save As New Album',
            disabled: submitting
          }]}
        />
        <LoadingSpinner show={submitting} />
      </form>
    </Modal>
  )
}

function Input (props) {
  return (
    <label>
      {props.label}
      <input {...props} />
      {props.touched && props.error &&
        <div className={classNames.error}>
          {props.error}
        </div>
      }
    </label>
  )
}

function ListPicker ({ value, onChange, lists }) {
  if (!lists) {
    return <LoadingSpinner />
  }
  return (
    <Checklist
      items={lists.map(getListOptions)}
      value={value}
      onChange={onChange}
    />
  )
}

function getListOptions (list) {
  return {
    value: list.id,
    title: list.name,
    subtitle: pluralize(JSON.parse(list.json_data).albums.length, 'album')
  }
}

function validate (values) {
  if (!values.name) {
    return {
      name: 'An album name is required'
    }
  }
  return {}
}

export default reduxForm({ form: 'saveAlbum', validate })(SaveAlbum)



// WEBPACK FOOTER //
// ./src/components/modals/SaveAlbum.js